import * as React from "react";
const SvgIndicator = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 21, viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 10, cy: 10.5, r: 4, fill: "#EE577D" }));
export default SvgIndicator;
